<app-service-settings-common
    [settingsKey]="SERVICE_SETTINGS_EPICRISIS_TYPE_KEY"
    [title]="'service.settings.epicrisis.header'"
></app-service-settings-common>
